import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function FullScreenIconTextToImage(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 16 16" {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
				<path
					d="M10.6667 2.66797L13.3334 2.66797M13.3334 2.66797L13.3334 5.33459M13.3334 2.66797L9.33341 6.6679M5.33342 13.3345L2.66675 13.3345M2.66675 13.3345L2.66675 10.6678M2.66675 13.3345L6.66675 9.33453"
					stroke="var(--primary-text-color)"
					stroke-width="1.25"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</SvgIcon>
	);
}

export default FullScreenIconTextToImage;
